"use client"

import { useEffect } from "react"

export function TawkChat() {
  useEffect(() => {
    // Get credentials from environment
    const propertyId = process.env.NEXT_PUBLIC_TAWK_PROPERTY_ID
    const widgetId = process.env.NEXT_PUBLIC_TAWK_WIDGET_ID

    // Don't load if credentials are not set
    if (!propertyId || !widgetId) {
      console.warn(
        "⚠️ Tawk.to credentials not configured.",
        "\nAdd these to your .env.local file:",
        "\nNEXT_PUBLIC_TAWK_PROPERTY_ID=your_property_id",
        "\nNEXT_PUBLIC_TAWK_WIDGET_ID=your_widget_id"
      )
      return
    }

    // Check if Tawk.to is already loaded
    if (window.Tawk_API) {
      console.log("✅ Tawk.to already loaded")
      return
    }

    console.log("🔄 Loading Tawk.to widget...")

    // Set up Tawk_API
    window.Tawk_API = window.Tawk_API || {}
    window.Tawk_LoadStart = new Date()

    // Create and append script
    const script = document.createElement("script")
    script.async = true
    script.src = `https://embed.tawk.to/${propertyId}/${widgetId}`
    script.setAttribute("crossorigin", "*")
    
    script.onload = () => {
      console.log("✅ Tawk.to widget loaded successfully!")
    }

    script.onerror = (error) => {
      console.error("❌ Failed to load Tawk.to widget:", error)
    }

    document.body.appendChild(script)

    // Cleanup function
    return () => {
      // Remove script when component unmounts
      if (script.parentNode) {
        script.parentNode.removeChild(script)
      }
      
      // Hide Tawk widget
      if (window.Tawk_API?.hideWidget) {
        window.Tawk_API.hideWidget()
      }
    }
  }, [])

  return null
}

// Extend Window interface for TypeScript
declare global {
  interface Window {
    Tawk_API?: any
    Tawk_LoadStart?: Date
  }
}
